import { setIsDemoMode } from '@/context/display';
import { store } from '@/context/store';

import { DEMO_NAME_TRIGGERS } from '../constants';

export function setDemoMode(firstName: string, lastName: string): void {
    const state = store.getState();
    const isDemoMode = state.displayReducer.partner.isDemoMode;

    const isNameMatch = DEMO_NAME_TRIGGERS.some(
        (trigger) =>
            firstName.toLocaleLowerCase() ===
                trigger.firstName.toLocaleLowerCase() &&
            lastName.toLocaleLowerCase() ===
                trigger.lastName.toLocaleLowerCase()
    );

    if (isNameMatch && !isDemoMode) {
        store.dispatch(setIsDemoMode(true));
    }

    if (!isNameMatch && isDemoMode) {
        store.dispatch(setIsDemoMode(false));
    }
}

export function isDemoMode(): boolean {
    const state = store.getState();
    const firstName = state.borrowerReducer.personalDetails?.firstName;
    const lastName = state.borrowerReducer.personalDetails?.lastName;

    if (!firstName || !lastName) {
        return false;
    }

    const isNameMatch = DEMO_NAME_TRIGGERS.some(
        (trigger) =>
            firstName.toLocaleLowerCase() ===
                trigger.firstName.toLocaleLowerCase() &&
            lastName.toLocaleLowerCase() ===
                trigger.lastName.toLocaleLowerCase()
    );

    return isNameMatch;
}
